import { ActivatedRouteSnapshot, Resolve, UrlSegment } from '@angular/router';
import { Injectable } from '@angular/core';
import { merge } from 'rxjs';
import { UserDAO } from '../../../../../core/services/dao/userDAO';
import { RoleDAO } from '../../../../../core/services/dao/roleDAO';
import { WaterBodyDAO } from '../../../../../core/services/dao/waterBodyDAO';
import { AuthService } from '../../../../../core/services/auth.service';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../../core/services/apiHelper';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class WaterBodiesFormResolve implements Resolve<any> {
  constructor(
    private userDAO: UserDAO,
    private roleDAO: RoleDAO,
    private waterBodyDAO: WaterBodyDAO,
    private authService: AuthService,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const sessionResolve = this.authService.checkSession();
    const waterBodiesResolve = this.waterBodyDAO.loadById(route.params.id);

    const mergeResolve = merge(sessionResolve, waterBodiesResolve);
    return mergeResolve.pipe(
      take(2),
      map((data) => data),
    );
  }
}
